const { Redirect } = require("@reach/router");
const { withPrefix } = require("gatsby");
const PropTypes = require("prop-types");
const React = require("react");
const { Helmet } = require("react-helmet");

const { createElement, Fragment } = React;

const WrapPageElement = ({ element, props: pageProps }) => {
  const { pageContext } = pageProps;
  return (
    <Fragment>
      <Helmet>
        <link
          rel="icon"
          type="image/png"
          sizes="128x128"
          href="/favicon-128x128.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="144x144"
          href="/favicon-144x144.png"
        />
      </Helmet>
      {pageContext.redirect &&
        createElement(Redirect, {
          from: withPrefix(pageContext.redirect.from),
          to: withPrefix(pageContext.redirect.to),
          noThrow: true,
        })}
      {element}
    </Fragment>
  );
};

WrapPageElement.propTypes = {
  element: PropTypes.element.isRequired,
  props: PropTypes.object.isRequired,
};

exports.wrapPageElement = WrapPageElement;
